var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProjectDiagramWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.6,8H6.4a.8.8,0,0,0-.8.8V12a.8.8,0,0,0,.8.8H9.6a.8.8,0,0,0,.8-.8V8.8A.8.8,0,0,0,9.6,8ZM4.8.8A.8.8,0,0,0,4,0H.8A.8.8,0,0,0,0,.8V4a.8.8,0,0,0,.8.8H3.193L5.022,8A1.6,1.6,0,0,1,6.4,7.2h.007L4.8,4.388V3.2h5.6V1.6H4.8ZM15.2,0H12a.8.8,0,0,0-.8.8V4a.8.8,0,0,0,.8.8h3.2A.8.8,0,0,0,16,4V.8A.8.8,0,0,0,15.2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectDiagramWhite);
export default __webpack_public_path__ + "static/media/iconProjectDiagramWhite.522e77312e4b5ad0324a4cdb3f6eff6c.svg";
export { ForwardRef as ReactComponent };